import { createApp, SetupContext } from 'vue'
import App from './App.vue'

export const mount = (props: SetupContext['attrs']): void => {
    const app = createApp(App, props)
    app.mount('#vue-deksoft')
}
